<template>
  <div class="row">
    <div class="small-12 columns">
      <div class="callout">
        <form action="/shop/orders/populate_quick_quote" method="post">
          <input type="hidden" name="comments" :value="comments" />
          <button
            type="submit"
            class="button orange rounded"
            style="width: 246px; float: right"
          >
            Finalize Quote
          </button>
        </form>

        <p>
          Prices at time of order acknowledgement apply and are subject to change. Titanium Industries reserves the right to make any corrections to prices
          quoted due to new information, errors, or any other significant changes. All orders are subject to a full contract review of all specifications and a 48-hour
          order approval process to verify all details, stock availability, and terms and conditions. All orders will be acknowledged by a T.I. salesperson.
        </p>

        <table class="stack unstriped">
          <thead class="no-border">
            <tr v-if="cartHasItems">
              <th>Product&nbsp;Description</th>
              <th>Specifications</th>
              <th>Quantity</th>
              <th>Unit&nbsp;Price</th>
              <th>Sub&nbsp;Total</th>
              <th />
            </tr>
          </thead>

          <tbody class="no-border">
            <line-item
              v-for="lineItem in reversedLineItems"
              :key="lineItem.id"
              :line-item="lineItem"
              @delete-line-item="deleteLineItem(lineItem.id)"
              @update-quantity="updateQuantity"
            />

            <template v-if="cartHasItems">
              <tr class="no-border">
                <td colspan="5" class="no-border">
                  &nbsp;
                </td>
              </tr>

              <tr class="no-border">
                <td colspan="3" class="no-border" rowspan="2">
                  <h5>Comments</h5>
                  <p>
                    Please provide any additional remarks, requests, or
                    pertinent information in the comment section below.
                  </p>
                  <textarea v-model="comments" name="comments" type="text" />
                </td>
                <th class="no-border">
                  Quote Total:
                </th>
                <td v-if="cartData.data.attributes.override_total == null" class="no-border">
                  {{ cartData.data.attributes.item_total }}
                </td>
                <td v-if="cartData.data.attributes.override_total" class="no-border">
                  {{ cartData.data.attributes.override_total }}
                </td>
              </tr>

              <tr class="no-border">
                <td colspan="5" class="no-border">
                  <form
                    action="/shop/orders/populate_quick_quote"
                    method="post"
                  >
                    <input type="hidden" name="comments" :value="comments" />
                    <button
                      type="submit"
                      class="button orange rounded"
                      style="width: 100%"
                    >
                      Finalize Quote
                    </button>
                  </form>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LineItem from "./MaterialsList/LineItem";

export default {
  components: {
    LineItem
  },
  props: {
    cartData: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      comments: ""
    };
  },
  computed: {
    cartHasItems() {
      return (
        Object.keys(this.cartData).length &&
        this.cartData.data.relationships.line_items.data.length > 0
      );
    },
    reversedLineItems() {
      const lineItems = this.cartData.included;

      if (lineItems) {
        return lineItems.reverse();
      } else {
        return [];
      }
    }
  },
  methods: {
    deleteLineItem(id) {
      this.$emit("delete-line-item", id);
    },
    updateQuantity(id, quantity) {
      this.$emit("update-quantity", id, quantity);
    }
  }
};
</script>

<style scoped>
input[type="text"] {
  color: initial;
  font-family: "Lato", "Helvetica, Arial";
  font-weight: initial;
  height: initial;
  text-transform: none;
}

textarea {
  resize: vertical;
}

thead {
  background: inherit;
}
</style>
